<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/77Z2rJ/CoverDesign.jpg?1685327424599" alt="This image is the cover for the book Helix"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Helix
      </h1>
      <p class="bookDescription body article font2">
        <p>When high school student James has trouble with his truck, Dylan, who is studying to be a mechanic, comes to the rescue. James thinks he hides his immediate attraction well, but is happy to be wrong when Dylan asks for his number. Since James is new to romance, they take things slowly, and because Dylan is in college, James keeps the budding relationship secret from his overprotective dad.</p> <p>Across town, Mark, a teacher and single father to James and his sister, Frankie, meets Steve at a bar for what both believe will be a quick hookup. Mark doesn’t see any reason to tell his kids about Steve or press Steve for details about Steve’s adopted son…. It’s just sex between them. Isn’t it?</p> <p>Two very different love stories grow side by side, each hidden from the other. But all of that changes at a family barbecue, when Mark decides it’s time for his kids to meet Steve and for him to meet James’s boyfriend, who none of them realize is Steve’s son, Dylan. The inevitable explosion means the two couples have some explaining to do to soothe the hurt feelings of their families—and lovers.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anna Martin
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b206bd18